import { useState } from 'react'
import { SearchAndFilter, SearchWrapper } from '@/components/SearchTemplateBox.styles'
import { ModalTypes, SearchQuery } from '@/types'
import Icon from './Icons'
import SearchModal from './SearchModal'
import { formatSearchParams } from '@/helpers/SearchHelper'
import { useAnalyticsSearchModalInteraction } from '@/hooks/AnalyticsSearchModalInteractionHook'
import { Button } from '@big-red-group/storefront-common-ui'

const SearchTemplateBox: React.FC<SearchQuery> = ({ part1Type, part2Type, part1, part2, part3, destinations }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInput, setSelectedInput] = useState('')
  const trackSearchModalInteraction = useAnalyticsSearchModalInteraction(true)

  const placement = 'SearchTemplateBox'
  const searchType: ModalTypes = 'generic'

  const handleOpenModal = (e: React.MouseEvent<Element, MouseEvent>, input?: string) => {
    e.stopPropagation() // so when, for example, "search" is clicked it does not propagate to "SearchAndFilter"
    input && setSelectedInput(input)
    setIsModalOpen(true)
    trackSearchModalInteraction({ toggle: 'on', placement, type: searchType })
  }

  const handleCloseModal = (performedSearch = false) => {
    setIsModalOpen(false)

    if (!performedSearch) {
      trackSearchModalInteraction({ toggle: 'off', placement, type: searchType })
    }
  }

  return (
    <>
      <SearchModal
        initialActiveInput={selectedInput}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        destinations={destinations}
        part1Type={part1Type}
        part2Type={part2Type}
        part1={part1}
        part2={part2}
        part3={part3}
        type={searchType}
        placement={placement}
        onSearch={trackSearchModalInteraction}
      />
      <SearchAndFilter onClick={(e) => handleOpenModal(e, 'location')}>
        <SearchWrapper>
          <div>
            <Icon name="search" data-testid="search-wrapper-icon" />
          </div>
          {/* TODO: Query params */}
          <p className="desktop-label" onClick={(e) => handleOpenModal(e, 'location')}>
            <span>Location</span>
            {formatSearchParams(part1Type, part2Type, part1, part2, part3).part1 || 'E.g. Gold Coast'}
          </p>
          <p className="desktop-label border-sides" onClick={(e) => handleOpenModal(e, 'experience')}>
            <span>Experience</span>
            {formatSearchParams(part1Type, part2Type, part1, part2, part3).part2 || 'All'}
          </p>
          <p className="desktop-label" onClick={(e) => handleOpenModal(e, 'date')}>
            <span>Date</span>
            {formatSearchParams(part1Type, part2Type, part1, part2, part3).part3 || 'Flexible'}
          </p>
          <p className="mobile-label" onClick={(e) => handleOpenModal(e, 'location')} data-testid="search-wrapper-search">
            Search
          </p>
          <Button onClick={(e) => handleOpenModal(e)}>Search</Button>
        </SearchWrapper>
      </SearchAndFilter>
    </>
  )
}

export default SearchTemplateBox
